import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-mes-cjs-terminal-register',
	templateUrl: './mes-cjs-terminal-register.component.html',
	styleUrls: ['./mes-cjs-terminal-register.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class MesCjsTerminalRegisterComponent {}
